import { FC, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'

import styles from './OperatingProfitReadMode.module.scss'

export interface IOperatingProfitReadModeProps {
  profit: Nullable<number>
  yoy: Nullable<number>
  profitTranslationKey?: string
  yoyTranslationKey?: string
}

export const OperatingProfitReadMode: FC<IOperatingProfitReadModeProps> = ({
  profit,
  yoy,
  profitTranslationKey = '',
  yoyTranslationKey = '',
}) => {
  const profitValue = useMemo(() => {
    if (profit === null) {
      return '-'
    }

    const formattedFinValue = getFormattedFinance(profit, {
      withCurrencySign: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })

    return `${formattedFinValue}M`
  }, [profit])

  const yoyValue = useMemo(() => {
    if (yoy === null) {
      return '-'
    }

    return `${yoy}%`
  }, [yoy])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{profitValue}</div>
        <div className={styles.label}>
          <Translation text={profitTranslationKey} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{yoyValue}</div>
        <div className={styles.label}>
          <Translation text={yoyTranslationKey} span />
        </div>
      </div>
    </div>
  )
}
